export default __webpack_public_path__ + "static/A5-4633f6dcbf299d7f1e6b1842f931c577.jpg";